/* hkskincart-2 收藏 (wishlist) — hearts on product cards + PDP, backed by the
 * membership App Proxy (/apps/membership/v2/wishlist*). Login state comes from
 * the proxy response, NEVER from Liquid customer (page cache serves the same
 * HTML to everyone). Prototype 2026-07-29. */
(() => {
  'use strict';
  const LIST_URL = '/apps/membership/v2/wishlist';
  const TOGGLE_URL = '/apps/membership/v2/wishlist_toggle';

  const state = { loaded: false, loggedIn: false, ids: new Set() };
  let loadPromise = null;

  function snapshot() {
    return { loggedIn: state.loggedIn, ids: Array.from(state.ids), count: state.ids.size };
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('wishlist:state', { detail: snapshot() }));
  }

  function loadState(force) {
    if (loadPromise && !force) return loadPromise;
    loadPromise = fetch(LIST_URL, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d && d.ok) {
          state.loaded = true;
          state.loggedIn = !!d.logged_in;
          state.ids = new Set((d.items || []).map((i) => String(i.product_id)));
          announce();
        }
        paintAll();
        return state;
      })
      .catch(() => state);
    return loadPromise;
  }

  function paint(btn) {
    const saved = state.ids.has(String(btn.getAttribute('data-product-id')));
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function paintAll(root) {
    (root || document).querySelectorAll('.wl-heart').forEach(paint);
    updateHeaderBadge();
  }

  function updateHeaderBadge() {
    const n = state.ids.size;
    document.querySelectorAll('[data-wl-header-badge]').forEach((el) => {
      el.hidden = !state.loaded || n === 0;
      el.textContent = n > 99 ? '99+' : String(n);
    });
  }

  async function toggle(btn) {
    if (btn.dataset.wlBusy) return;
    await (loadPromise || loadState());
    if (!state.loggedIn) {
      const login = window.__wlLoginUrl || '/account/login';
      const back = location.pathname + location.search;
      location.href = login + (login.indexOf('?') > -1 ? '&' : '?') +
        'return_url=' + encodeURIComponent(back);
      return;
    }
    btn.dataset.wlBusy = '1';
    const id = String(btn.getAttribute('data-product-id'));
    const had = state.ids.has(id);
    // optimistic flip; reverted on failure
    if (had) state.ids.delete(id); else state.ids.add(id);
    paintAll();
    try {
      const body = new URLSearchParams({
        product_id: id,
        handle: btn.getAttribute('data-handle') || '',
        title: btn.getAttribute('data-title') || '',
      });
      const r = await fetch(TOGGLE_URL, { method: 'POST', body });
      const d = await r.json().catch(() => null);
      if (!d || !d.ok) throw new Error((d && d.error) || 'toggle_failed');
      if (d.saved) state.ids.add(id); else state.ids.delete(id);
    } catch (e) {
      if (had) state.ids.add(id); else state.ids.delete(id);
    }
    delete btn.dataset.wlBusy;
    paintAll();
    announce();
  }

  // capture phase: beat the product-card link / quick-add handlers
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wl-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  // product grids re-render on filter/sort — repaint hearts that appear later
  const mo = new MutationObserver(() => {
    if (!state.loaded) return;
    clearTimeout(mo._t);
    mo._t = setTimeout(() => paintAll(), 120);
  });

  function init() {
    mo.observe(document.body, { childList: true, subtree: true });
    loadState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.HK2Wishlist = { reload: () => loadState(true), snapshot };
})();
